import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NutritionInfoSection = ({ nutritionEstimate }) => {
  const { t } = useTranslation();

  if (!nutritionEstimate) {
    return null;
  }

  const nutritionItems = [
    { label: t('foodAnalysisObj.calories'), value: nutritionEstimate.calories, unit: 'kcal' },
    { label: t('foodAnalysisObj.protein'), value: nutritionEstimate.protein_g, unit: 'g' },
    { label: t('foodAnalysisObj.carbs'), value: nutritionEstimate.carbohydrates_g, unit: 'g' },
    { label: t('foodAnalysisObj.fat'), value: nutritionEstimate.fat_g, unit: 'g' },
    { label: t('foodAnalysisObj.fiber'), value: nutritionEstimate.fiber_g, unit: 'g' },
    { label: t('foodAnalysisObj.sugar'), value: nutritionEstimate.sugar_g, unit: 'g' },
    { label: t('foodAnalysisObj.sodium'), value: nutritionEstimate.sodium_mg, unit: 'mg' },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#333' }}>
        {t('nutritionInformation')}
      </Typography>
      <Grid container spacing={2}>
        {nutritionItems.map((item, index) => (
          <Grid item xs={6} sm={4} md={3} key={index}>
            <Box
              sx={{
                textAlign: 'center',
                padding: '12px',
                background: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                transition: 'all 0.2s ease',
                '&:hover': {
                  background: '#e9ecef',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              <Typography variant="h6" sx={{ color: '#26786A', fontWeight: 600 }}>
                {item.value || 0}
              </Typography>
              <Typography variant="caption" sx={{ color: '#666' }}>
                {item.label}
              </Typography>
              <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>
                {item.unit}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default NutritionInfoSection;
